/**
 * useReels
 */
import { useState, useCallback } from 'react';

import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';
import {
    useDidUpdate,
} from 'bdvp-common/src/hooks';
import useMediaConfig from '../config/useMediaConfig';
import useUserData from './useUserData';

const {
    useQuery,
} = ApolloLib;
const {
    GET_REELS,
} = Queries;
const INITIAL_PAGE = 0;

const useReels = (userId, options = {}) => {

    const {
        ssr = false,
        limit = 20,
        fetchPolicy = 'network-only',
    } = options;

    const config = useMediaConfig();
    const { data: userData = {}, loading: userDataLoading } = useUserData();
    const { isLoggedIn = false, userId: userDataId = '' } = userData;

    const context = {};
    if (isLoggedIn && userDataId === userId && config.server) {

        context.headers = {
            'Cache-Control': 'no-store',
        };
        context.uri = `${config.server}/graphql?bypass=true`;

    }

    const [
        page,
        setPage,
    ] = useState(INITIAL_PAGE);

    const [
        loadingMore,
        setLoadingMore,
    ] = useState(false);

    useDidUpdate(() => {

        setPage(INITIAL_PAGE);

    }, [userId]);

    const {
        loading,
        data,
        error,
        fetchMore,
    } = useQuery(
        GET_REELS,
        {
            variables: {
                userId,
                limit,
                page: INITIAL_PAGE,
            },
            ssr,
            skip: userDataLoading,
            fetchPolicy,
            context,
        }
    );

    const fetchMoreData = useCallback(() => {

        const nextPage = page + 1;
        setLoadingMore(true);

        return fetchMore({
            variables: { page: nextPage },
            updateQuery: (prev, { fetchMoreResult }) => {

                setLoadingMore(false);
                setPage(nextPage);

                if (
                    !fetchMoreResult
                    || fetchMoreResult?.getReels?.reels?.length < 1
                ) return prev;

                return Object.assign({}, prev, {
                    getReels: {
                        total: fetchMoreResult.getReels.total,
                        reels: [
                            ...prev.getReels.reels,
                            ...fetchMoreResult.getReels.reels,
                        ],
                        __typename: 'PagedReelResponse',
                    },
                });

            },
        });

    }, [
        fetchMore,
        page,
        setPage,
    ]);

    return {
        loading: loading || userDataLoading,
        data,
        error,
        loadingMore,
        fetchMoreData,
    };

};

export default useReels;
